import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { useFirestore } from 'utils/firebase';
import { MaintenanceStatus, type Status } from './constants';
import { COLLECTIONS } from 'constants/firestoreCollections';

export const useMaintenanceMode = (): Status => {
  const db = useFirestore();
  const [status, setStatus] = useState<Status>(MaintenanceStatus.LOADING);

  useEffect(() => {
    const unsubscribe = onSnapshot(
      doc(db, COLLECTIONS.CONFIG, 'maintenance'),
      snapshot => {
        const isMaintenance = snapshot.exists() ? (snapshot.data()?.active ?? false) : false;
        setStatus(isMaintenance ? MaintenanceStatus.MAINTENANCE : MaintenanceStatus.OPERATIONAL);
      },
      err => {
        console.error('Firestore maintenance check failed:', err);
        setStatus(MaintenanceStatus.OPERATIONAL);
      },
    );

    return unsubscribe;
  }, [db]);

  return status;
};
